import { useQuery } from "react-query";
import subjectPlanAPI from "../../../api/subjectPlanAPI";

export const useSubjectPlans = () => useQuery("plans", subjectPlanAPI.fetchPlans);
